import { render, staticRenderFns } from "./study-name-input.vue?vue&type=template&id=04706fbd&scoped=true&"
import script from "./study-name-input.vue?vue&type=script&lang=ts&"
export * from "./study-name-input.vue?vue&type=script&lang=ts&"
import style0 from "./study-name-input.vue?vue&type=style&index=0&id=04706fbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04706fbd",
  null
  
)

export default component.exports